import { useContext } from 'react';

import Context from '../../Context';

const ContainerComponent = ({ children }) => {
  const { isLoading, price, classNames } = useContext(Context);

  return children({ price, isLoading, classNames });
};

ContainerComponent.displayName = 'LineItem-Price-container';

export default ContainerComponent;
